// Keep the control a usable size in CSS pixels, including after pinch zoom.
export function rotationHandle(pts,width,height,displayWidth){
 const unit=width/(displayWidth||width),radius=18*unit,hitRadius=28*unit;
 const margin=hitRadius+4*unit,offset=38*unit;
 const xs=pts.map(p=>p[0]),ys=pts.map(p=>p[1]);
 const cx=xs.reduce((a,b)=>a+b,0)/pts.length,cy=ys.reduce((a,b)=>a+b,0)/pts.length;
 let x=cx,y=Math.min(...ys)-offset;
 if(y<margin){
  if(Math.max(...ys)+offset<=height-margin)y=Math.max(...ys)+offset;
  else if(Math.max(...xs)+offset<=width-margin){x=Math.max(...xs)+offset;y=cy;}
  else if(Math.min(...xs)-offset>=margin){x=Math.min(...xs)-offset;y=cy;}
 }
 x=Math.max(margin,Math.min(width-margin,x));y=Math.max(margin,Math.min(height-margin,y));
 return {x,y,radius,hitRadius,fontSize:24*unit,lineWidth:2*unit};
}
